import React, { useContext } from "react";
import { GameStatus } from "../constants";

const initialState = {
  status: GameStatus.STOPPED,
  round: "firstRound",
  score: 0,
};

const GameStatusContext = React.createContext(initialState);

function GameStatusProvider({ children }) {
  const gameStatus = React.useState(initialState);

  return (
    <GameStatusContext.Provider value={gameStatus}>
      {children}
    </GameStatusContext.Provider>
  );
}

export const useGameStatusContext = () => useContext(GameStatusContext);

export default GameStatusProvider;
